import React, { useEffect } from "react";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCarousel } from "../../../features/carouselSlice/CarouselSlice";

const Carousel = () => {
  const carousel = useSelector((state) => state.carousel);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCarousel());
  }, []);
  return (
    <div className=" w-full">
    <Slider previousButton={null} nextButton={null} >
      {carousel.data?.map((item, index) => {
        return (
          <div className=" absolute top-0 bg-primary-blue " key={index}>
            <img
              alt=""
              className=" h-full w-full object-fill"
              src={item.image}
            />
          </div>
        );
      })}
    </Slider>
    </div>
  );
};

export default Carousel;
